import {
  lgBumps,
  MainSection,
  NotificationContainer,
  pageEntranceSpringValues,
  SideSection,
  StickySidebar,
  WideContainer,
  xlBumps,
  xxlBumps,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { animated, useSpring } from 'react-spring'

import { getPolicyVersion } from '../../../../../../domain'
import { useCurrentPath } from '../../../../../../infrastructure/routing'
import { RenewalBanner } from '../../../../../homePage/organisms/RenewalBanner'
import {
  PolicyAddOnSection,
  PolicyAutoRenewalSection,
  PolicyCoverSection,
  PolicyDetailsView,
  PolicyExcessSection,
} from '../../../../../organisms/policy'
import { ProductFaqSection } from '../../../../../organisms/product'
import { PolicyPromotionBanner } from '../../../../../organisms/promotion'
import { usePolicy } from '../../../policyContext'
import { PolicySidebar } from '../../PolicySidebar'
import { PolicyCancellationNotification } from '../components/PolicyCancellationNotification'

export const PolicyDetailsTab: FunctionComponent = () => {
  const path = useCurrentPath()

  const { policy } = usePolicy()
  const { quote } = getPolicyVersion(policy)

  const spring = useSpring(pageEntranceSpringValues)

  return (
    <animated.div style={spring}>
      <WideContainer>
        <NotificationContainer mb={xlBumps}>
          <RenewalBanner type='standalone' />
          <PolicyCancellationNotification policy={policy} basePath={path} />
          <PolicyPromotionBanner />
        </NotificationContainer>
      </WideContainer>
      <WideContainer variant='sidebar'>
        <StickySidebar variant='offset'>
          <SideSection>
            <PolicySidebar key='desktop' />
          </SideSection>
        </StickySidebar>
        <MainSection>
          <PolicySidebar key='mobile' displayOn='mobile' mb={lgBumps} />
          <PolicyDetailsView mb={xxlBumps} />
          <PolicyAutoRenewalSection policy={policy} mb={xxlBumps} />
          <PolicyCoverSection mb={xxlBumps} />
          <PolicyAddOnSection policy={policy} quote={quote} mb={xxlBumps} />
          <PolicyExcessSection mb={xxlBumps} />
          <ProductFaqSection />
        </MainSection>
      </WideContainer>
    </animated.div>
  )
}
